import React from "react";
import { Text } from "basis";

import {
    FEES,
    MONTHLY_FEES,
    RATES,
} from "../../../../components/Promotions/Description/constants";
import { WIDGET_DEFAULT_MINIMUM_AMOUNT_CENTS } from "../../../../../assets/constants";
import { LessThanMinAmount } from "./LessThanMinAmount";

export const DeferredAU = ({ order }) => {
    //   if (order?.price < WIDGET_DEFAULT_MINIMUM_AMOUNT_CENTS) {
    //     return <LessThanMinAmount />;
    //   }

    return (
        <>
            <Text  margin="0 0 3" align="center">
                Make payments at any time it suits you during the plan period. Monthly credit card fee applies, currently ${MONTHLY_FEES["AUD"]} (subject to change). After the interest free plan ends interest will be charged on any outstanding balance at the Expired Plan Rate, currently {RATES["GEM_VISA_AU"]}% p.a. (subject to change).
            </Text>
            <Text align="center" margin="3 0 0">
                New customers must apply and be approved for a Latitude {order?.checkoutTemplate === 'HN' ? 'GO Mastercard' : 'Gem Visa credit card'}.
            </Text>
        </>
    );
};